module.exports = kolibriCoreAppGlobal.coreVue.components.GenderSelect;